import { Redirect, Route as ReactRoute } from "react-router-dom";
import Cookies from "universal-cookie";

import { useAuth } from "../hooks/useAuth";

const Route = ({
  isPrivate = false,
  component: Component,
  permissionsRoute = [],
  ...rest
}) => {
  const cookies = new Cookies();
  const { token, permissions } = useAuth();
  const distributionCenterId = cookies.get("distributionCenterId");

  const isPermission =
    permissionsRoute.length === 0
      ? true
      : permissionsRoute.some(permission => permissions.includes(permission));

  return (
    <ReactRoute
      {...rest}
      render={({ location }) => {
        if (!!token && location.pathname === "/distribution-center-selection") {
          return <Component />;
        }

        if (!token && location.pathname === "/login") {
          return <Component />;
        }

        if (isPrivate === !!token && isPermission) {
          if (!distributionCenterId) {
            return (
              <Redirect
                to={{
                  pathname: "/distribution-center-selection",
                  state: { from: location }
                }}
              />
            );
          }
          return <Component />;
        } else if (isPrivate === !!token && !isPermission) {
          if (!distributionCenterId) {
            return (
              <Redirect
                to={{
                  pathname: "/distribution-center-selection",
                  state: { from: location }
                }}
              />
            );
          }
          return (
            <Redirect
              to={{
                pathname: "/app",
                state: { from: location }
              }}
            />
          );
        } else {
          return (
            <Redirect
              to={{
                pathname: isPrivate ? "/login" : "/app",
                state: { from: location }
              }}
            />
          );
        }
      }}
    />
  );
};

export default Route;
